import { render } from "./add-course.vue?vue&type=template&id=db813c12"
import script from "./add-course.vue?vue&type=script&lang=js"
export * from "./add-course.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__